import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=00a09f71&scoped=true&"
var script = {}
import style0 from "./ArrowIcon.vue?vue&type=style&index=0&id=00a09f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a09f71",
  null
  
)

export default component.exports